import base64 from 'base-64'
import Cookies from 'js-cookie'

const TOKEN = 'token'
const TOKEN_EXPIRES = 'token_expires'
const USER = 'user'
// const LANGUAGE = 'language'

function getCookie(key) {
    const value = Cookies.get(key)
    let setValue = ''
    if (typeof value === 'string') {
        setValue = base64.decode(value)
    }
    return setValue
}

function setCookie(key, value) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    Cookies.set(key, setValue)
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function setToken(props) {
    clearToken()
    const { token, expires, user } = props

    if (typeof token !== "undefined") setCookie(TOKEN, token)
    if (typeof expires !== "undefined") setCookie(TOKEN_EXPIRES, expires)
    if (typeof user !== "undefined") setCookie(USER, user)
}

export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(TOKEN_EXPIRES)
    removeCookie(USER)
}

export function getAllCookies() {
    if (!getCookie(TOKEN)) return {}
    return {
        [TOKEN]: getCookie(TOKEN),
        [TOKEN_EXPIRES]: getCookie(TOKEN_EXPIRES),
        [USER]: getCookie(USER),
    }
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getLanguage() {
    return 'EN'
    // return getCookie(LANGUAGE)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js